import { ReactNode } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import clsx from 'clsx';

export interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
  badge?: number | string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = '',
}) => {
  const { theme } = useTheme();
  const isCentered = className.includes('justify-center');

  return (
    <div className={clsx('mb-6', className)}>
      <div className={clsx(
        'border-b',
        theme === 'dark' ? 'border-gray-700' : 'border-gray-300'
      )}>
        <nav className={clsx('-mb-px flex space-x-8', isCentered && 'justify-center')}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={clsx(
                'py-4 px-1 border-b-2 font-medium text-sm transition-colors',
                activeTab === tab.id
                  ? theme === 'dark'
                    ? 'border-orange-400 text-orange-300'
                    : 'border-orange-500 text-orange-600'
                  : clsx(
                      'border-transparent',
                      theme === 'dark'
                        ? 'text-gray-400 hover:text-gray-300 hover:border-gray-300'
                        : 'text-gray-600 hover:text-gray-900 hover:border-gray-400'
                    )
              )}
            >
              <div className="flex items-center space-x-2">
                {tab.icon && <span className="h-5 w-5">{tab.icon}</span>}
                <span>{tab.label}</span>
                {tab.badge !== undefined && tab.badge > 0 && (
                  <span className={clsx(
                    'ml-2 px-2 py-1 text-xs rounded-full font-semibold',
                    theme === 'dark'
                      ? 'bg-red-500 text-white'
                      : 'bg-red-500 text-white'
                  )}>
                    {tab.badge}
                  </span>
                )}
              </div>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabNavigation;

